var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
var ValidateError = function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 26 26", width: "100%", height: "100%" }, props),
        React.createElement("path", { fill: color, fillRule: "evenodd", d: "M13 0c1.794 0 3.483.339 5.065 1.016a13.045 13.045 0 0 1 4.14 2.78 13.045 13.045 0 0 1 2.78 4.139C25.66 9.517 26 11.205 26 13c0 1.794-.339 3.483-1.016 5.065a13.045 13.045 0 0 1-2.78 4.14 13.045 13.045 0 0 1-4.139 2.78C16.483 25.66 14.795 26 13 26c-1.794 0-3.483-.339-5.065-1.016a13.045 13.045 0 0 1-4.14-2.78 13.045 13.045 0 0 1-2.78-4.139C.34 16.483 0 14.795 0 13c0-1.794.339-3.483 1.016-5.065a13.045 13.045 0 0 1 2.78-4.14 13.045 13.045 0 0 1 4.139-2.78C9.517.34 11.205 0 13 0zm.5 17h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm0-10h-1a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5z" })));
};
ValidateError.defaultProps = {
    color: '#E03636',
};
export default ValidateError;
//# sourceMappingURL=ValidateError.js.map